import React, { JSX } from "react";

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

interface NavbarProps {
    links?: Array<JSX.Element>
}

export default function AppBar({ links }: NavbarProps): JSX.Element {
    return (
        <Navbar expand="lg" className="bg-dark row">
            <Container className={"justify-content-start mx-md-3"}>
                <Navbar.Brand href="/" className={links ? "col-md-auto col-2 ms-2" : "ms-4"}>
                    <img src={"/logo.png"} alt={"logo"} width={"80px"} height={"80px"}/>
                </Navbar.Brand>
                <Nav className={links ? "col-md-auto col-7 text-md-start text-center" : "col-md-auto col-8"}>
                    <Nav.Link className={"text-light p-0"} href={"/"}>
                        <h2>M&S A.S. GARAGE</h2>
                    </Nav.Link>
                </Nav>
                {
                    links && (
                        <div className={"col-md-auto col-2"}>
                            <Navbar.Toggle className={"bg-light"}/>
                        </div>
                    )
                }
                {
                    links && (
                        <Navbar.Collapse id="basic-navbar-nav" className={"justify-content-end col-md-auto"}>
                            {
                                links.map((link) => (link))
                            }
                        </Navbar.Collapse>
                    )
                }
            </Container>
        </Navbar>
    );
};